// Import the functions you need from the SDKs you need

import firebase from "firebase";
// import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	// New

	apiKey: "AIzaSyCuhLnL3vsm0Djr_76OE2rT6uPT5tIYR5E",
	authDomain: "wrna-a9268.firebaseapp.com",
	projectId: "wrna-a9268",
	storageBucket: "wrna-a9268.appspot.com",
	appId: "1:278877537004:web:5a533d63db3e61d0901bc9",
	measurementId: "G-6KKVECS7J9"

	// Old

	// apiKey: "AIzaSyAK1SKpBZLzN4pUYA6wsH73bh1NfESnzvk",
	// authDomain: "whip-mvp.firebaseapp.com",
	// databaseURL: "https://whip-mvp.firebaseio.com",
	// projectId: "whip-mvp",
	// storageBucket: "whip-mvp.appspot.com",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const storage = firebase.storage();

export default firebase;
